<rs-web-side-sheet-form
  [showNav]="false"
  [showNextOrDoneButton]="false"
  (dismiss)="$event.dismiss()"
>
  <h1 sidesheet-title>
    {{ headerText() | translate }}
  </h1>

  <ng-template rsWebSideSheetContent>
    <div class="content-container">
      @switch (successAmount()) {
        @case (response()?.changeRequestStatuses?.length) {
          <ng-container [ngTemplateOutlet]="successTpl" />
        }

        @case (0) {
          <ng-container [ngTemplateOutlet]="errorTpl" />
        }

        @default {
          <ng-container [ngTemplateOutlet]="partialSuccessTpl" />
        }
      }
    </div>
  </ng-template>
</rs-web-side-sheet-form>

<!--SUCCESS TEMPLATE-->
<ng-template #successTpl>
  <rs-web-whitelabel-image
    [whitelabelImage]="whitelabelImage.GENERAL_SUCCESS"
    [altTag]="WhitelabelImageAltTag.GENERAL_SUCCESS | translate"
  />
  <h2>{{ 'general.done' | translate }}</h2>
  <p class="default-s">{{ 'user_edit_success_desc_payment' | translate }}</p>
  <p class="default-s fw-bold">{{ 'user_edit_success_desc_2' | translate }}</p>
</ng-template>

<!--PARTIAL SUCCESS TEMPLATE-->
<ng-template #partialSuccessTpl>
  <rs-web-whitelabel-image
    [whitelabelImage]="whitelabelImage.ERROR"
    [altTag]="WhitelabelImageAltTag.ERROR | translate"
  />
  <h2>{{ 'error_screen.title_l' | translate }}</h2>
  <p class="default-s">{{ 'user_payment_edit.half_error_desc_1' | translate }}</p>
  @for (error of contractErrors(); track error) {
    <p class="default-s fw-bold">{{ error }}</p>
  }
  <p class="default-s">{{ 'user_payment_edit.half_error_desc_2' | translate }}</p>
  <p class="default-s">{{ 'user_payment_edit.half_error_desc_3' | translate }}</p>
</ng-template>

<!--ERROR SUCCESS TEMPLATE-->
<ng-template #errorTpl>
  <rs-web-whitelabel-image
    [whitelabelImage]="whitelabelImage.ERROR"
    [altTag]="WhitelabelImageAltTag.ERROR | translate"
  />
  <h2>{{ 'error_screen.title_l' | translate }}</h2>
  <p class="default-s">{{ 'user_payment_edit.error_desc_1' | translate }}</p>
  <p class="default-s">{{ 'user_payment_edit.error_desc_2' | translate }}</p>
</ng-template>
